import { PagePermissionEnum } from '@/types/enum/PermissionEnum';

export default {
	tabs: {
		users: {
			title: 'Utilisateurs',
			component: 'ProjectUsers',
			permissions: [PagePermissionEnum.PROJECT]
		}
	}
};
